import { Navigate, useParams } from 'react-router';
import { useFund } from '@/hooks/react-query/useFunds';
import { DrawdownCreateView } from '@/components/drawdowns/drawdown-create/DrawdownCreateView';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { AlertCircle } from 'lucide-react';

export default function DrawdownCreatePage() {
  const { fundId } = useParams<{ fundId: string }>();
  const { data: fund, isLoading, isError } = useFund(fundId || '');

  if (!fundId) {
    return <Navigate to="/app/funds" replace />;
  }

  if (isLoading) {
    return (
      <div className="max-w-4xl mx-auto p-6">
        <div className="animate-pulse space-y-4">
          <div className="h-8 bg-muted rounded w-48" />
          <div className="h-64 bg-muted rounded" />
        </div>
      </div>
    );
  }

  if (isError || !fund) {
    return (
      <div className="max-w-4xl mx-auto p-6">
        <Alert variant="destructive">
          <AlertCircle className="h-4 w-4" />
          <AlertDescription>
            Failed to load fund details. Please go back and try again.
          </AlertDescription>
        </Alert>
      </div>
    );
  }

  return <DrawdownCreateView fundId={fundId} fund={fund} />;
}